import Http from "../http";

class RiderServices{
    static async getDrivers(serviceType){
        console.log("getDrivers serviceType",serviceType)
        return Http.get(`/riders?serviceType=${serviceType}`);
    }
    static async getDriversDashBoard(serviceType){
        return Http.get(`/ridersForDashBoard?serviceType=${serviceType}`);
    }
    static async getDriver(id){
        return Http.get(`/riders/${id}`);
    }
    static async getDriverTripcount(id){
        return Http.get(`/rider-trip-counts/${id}`);
    }
    static async updateRider(id,data){
        console.log("========================================data in the riderServices",data)
        return Http.update(`/riders/${id}`,data)
    }
    static async getAllDriverTripsCounts(){
        return Http.get("/rider-trip-counts");
    }
    static async getDriverEarnings(id){
        return Http.get(`/rider-earnings/${id}`);
    }
    
    static async getRiderBids(id, { page, rowsPerPage }) {
        // Include page and rowsPerPage in the API call as query parameters
        return Http.get(`/riderBid/${id}?page=${page}&pageSize=${rowsPerPage}`);
    }
}
export default RiderServices